import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Schema} from '../class/schema';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {BsModalService} from 'ngx-bootstrap/modal';
import {RoleDataService} from '../role-service/data.service';
import {RoleJsPlumbService} from '../role-service/jsPlumb.service';
import {AccountInfoService} from '../../user/account-info.service';

@Component({
    selector: 'app-role-schema',
    templateUrl: './role-schema.component.html',
    styleUrls: ['./role-schema.component.scss']
})
export class RoleSchemaComponent {

    @Input() mySchema: Schema;
    @Input() inputDataService: any;
    @Input() userExcludedPermissions: any;
    @Input() inputJsPlumbService: any;
    @Input() first;
    @Input() last;
    @Input() is_pivot;
    @Input() belongsTo;
    @Input() previewBlock;
    @Output() onDeletingSchema: EventEmitter<any> = new EventEmitter<any>();

    private bsModalRef: BsModalRef;

    constructor(private bsModalService: BsModalService,
                private dataService: RoleDataService,
                public accountInfoService: AccountInfoService,
                private jsPlumbService: RoleJsPlumbService,
                public platform: LeftpanelComponent) {
    }

    ngOnInit() {
        this.dataService = this.inputDataService;
        this.jsPlumbService = this.inputJsPlumbService;
    }

    ngAfterViewInit() {
        this.jsPlumbService.initSchema(this.mySchema);
        if (this.userExcludedPermissions && this.userExcludedPermissions.includes(this.mySchema.name)) {
            if (this.belongsTo === 'Permission Groups') {
                document.getElementById(this.mySchema.getElementId()).style.textDecoration = 'line-through';
            }
        }
    }

    ngOnDestroy() {
        this.jsPlumbService.destroySchema(this.mySchema);
    }

    // private editSchema():void{
    //   this.bsModalRef = this.bsModalService.show( ModalSchemaComponent, {initialState:{
    //     mode:'edit',
    //     schema: this.mySchema,
    //     use_laravel_auth: this.dataService.data.use_laravel_auth,
    //     parent_model: this.dataService.data.getModelById(this.mySchema.parent_id)
    //   }} );
    // }
    //
    public deleteSchema() {
        this.onDeletingSchema.emit(this.mySchema);
        //this.dataService.deleteSchema(this.mySchema);
    }


    private moveupSchema() {
        if (!this.first) {
            this.dataService.moveSchema(this.mySchema, -1);
        }
    }

    private movedownSchema() {
        if (!this.last) {
            this.dataService.moveSchema(this.mySchema, 1);
        }
    }

}
